import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './RepoCard.module.scss';

const LangColors = {
    Python: '#3572A5', JavaScript: '#f1e05a', TypeScript: '#2b7489',
    React: '#61dafb', Go: '#00ADD8', Rust: '#dea584', Java: '#b07219',
    'C++': '#f34b7d', C: '#555555', PHP: '#4F5D95', Ruby: '#701516',
    Swift: '#ffac45', Kotlin: '#F18E33', HTML: '#e34c26', CSS: '#563d7c',
    SCSS: '#c6538c',
};

function timeAgo(dateStr) {
    if (!dateStr) return '';
    let d = new Date(dateStr);
    if (isNaN(d.getTime())) {
        const m = dateStr.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})/);
        if (m) d = new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5]);
    }
    if (isNaN(d.getTime())) return dateStr;
    const diff = Date.now() - d.getTime();
    const minutes = Math.floor(diff / 60000);
    if (minutes < 60) return `${minutes} мин. назад`;
    const h = Math.floor(minutes / 60);
    if (h < 24) return `${h} ч. назад`;
    const day = Math.floor(h / 24);
    if (day < 30) return `${day} дн. назад`;
    return d.toLocaleDateString('ru-RU');
}

export default function RepoCard({ repo }) {
    const navigate = useNavigate();
    const langColor = LangColors[repo.language] || '#9D3EF7';
    return (
        <div className={styles.card} onClick={() => navigate(`/ncoreboard/${repo.owner?.username}/${repo.slug}`)}>
            <div className={styles.header}>
                <div className={styles.repoIcon}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h16V5H4zm2 3h2v2H6V8zm4 0h6v2h-6V8zm-4 4h2v2H6v-2zm4 0h6v2h-6v-2z"/>
                    </svg>
                </div>
                <div className={styles.repoMeta}>
                    <span className={styles.owner}>{repo.owner?.username}/</span>
                    <span className={styles.name}>{repo.name}</span>
                </div>
                <span className={`${styles.badge} ${repo.visibility === 'private' ? styles.private : styles.public}`}>
                    {repo.visibility === 'private' ? 'Приватный' : 'Публичный'}
                </span>
                {repo.is_archived && <span className={styles.archiveBadge}>Архив</span>}
                {repo.forked_from && <span className={styles.forkBadge}>Форк</span>}
            </div>

            {repo.description && (
                <p className={styles.description}>{repo.description}</p>
            )}

            {repo.topics?.length > 0 && (
                <div className={styles.topics}>
                    {repo.topics.slice(0, 5).map((t, i) => (
                        <span key={i} className={styles.topic}>{t}</span>
                    ))}
                </div>
            )}

            <div className={styles.footer}>
                {repo.language && (
                    <span className={styles.lang}>
                        <span className={styles.langDot} style={{ background: langColor }} />
                        {repo.language}
                    </span>
                )}
                <span className={styles.stat} title="Звёзды">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                    {repo.stars_count}
                </span>
                <span className={styles.stat} title="Форки">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><circle cx="18" cy="6" r="3"/>
                        <path d="M18 9v1a2 2 0 01-2 2H8a2 2 0 01-2-2V9M12 12v3"/>
                    </svg>
                    {repo.forks_count}
                </span>
                <span className={styles.updatedAt}>
                    Обновлён {timeAgo(repo.updated_at)}
                </span>
            </div>
        </div>
    );
}
